import ReleaseRentWithoutInvoiceError from './ReleaseRentWithoutInvoiceError';
class WithoutInvoiceDispersionNotFinished extends ReleaseRentWithoutInvoiceError {
    constructor(options) {
        super('A previous rent dispersion of this trader is still in progress.', options);
    }
}
export default WithoutInvoiceDispersionNotFinished;
